import { IntegrationsAgreggatedSyncableStateValuesEnum } from 'generated/resources/datatable.graphql'
import { IntegrationsCapabilityModeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { type Configuration } from 'modules/integrations/hooks/SyncContext'

const isExportMode = (capabilityMode?: IntegrationsCapabilityModeEnum | null): boolean => {
  return capabilityMode === 'file'
}

const getFilterLabel = (capabilityMode?: IntegrationsCapabilityModeEnum | null): string => {
  return isExportMode(capabilityMode)
    ? i18n.t('integrations.filters.export_status.export_status_label')
    : i18n.t('integrations.filters.sync_status.sync_status_label')
}

const getFilterOptionsForCapabilityMode = (
  capabilityMode?: IntegrationsCapabilityModeEnum | null
): Array<{
  value: IntegrationsAgreggatedSyncableStateValuesEnum
  label: string
}> => {
  if (isExportMode(capabilityMode)) {
    return [
      { value: 'failed', label: i18n.t('integrations.filters.export_status.failed') },
      { value: 'synced', label: i18n.t('integrations.filters.export_status.exported') },
      {
        value: 'partially_synced',
        label: i18n.t('integrations.filters.export_status.partially_exported'),
      },
      { value: 'pending', label: i18n.t('integrations.filters.export_status.pending') },
      { value: 'outdated', label: i18n.t('integrations.filters.export_status.outdated') },
    ]
  }

  return [
    { value: 'failed', label: i18n.t('integrations.filters.sync_status.failed') },
    {
      value: 'partially_synced',
      label: i18n.t('integrations.filters.sync_status.partially_synced'),
    },
    { value: 'pending', label: i18n.t('integrations.filters.sync_status.pending') },
    { value: 'outdated', label: i18n.t('integrations.filters.sync_status.outdated') },
    { value: 'synced', label: i18n.t('integrations.filters.sync_status.synced') },
  ]
}

const getFilterOptions = (
  configuration: Configuration,
  capabilityMode?: IntegrationsCapabilityModeEnum | null
): Array<{
  value: IntegrationsAgreggatedSyncableStateValuesEnum
  label: string
}> => {
  const filterOptions = getFilterOptionsForCapabilityMode(capabilityMode)

  if (!configuration.syncableStatusesFilter) return filterOptions

  const allowedValues = new Set(configuration.syncableStatusesFilter)

  return filterOptions.filter((option) => allowedValues.has(option.value))
}

export const syncStatusFilter = (
  configuration: Configuration,
  capabilityMode?: IntegrationsCapabilityModeEnum | null
) => {
  return {
    integrationsAgreggatedSyncableStates: {
      label: getFilterLabel(capabilityMode),
      type: 'in' as const,
      options: {
        options: getFilterOptions(configuration, capabilityMode),
      },
    },
  }
}
